// src/pages/NotificationSettings/NotificationSettings.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import NotificationConfig from '../../components/NotificationConfig/NotificationConfig';

const NotificationSettings = () => {
    return (
        <>
            <Helmet>
                <title>Configuración de Notificaciones - PetitPrime</title>
                <meta name="description" content="Configura los canales de notificación para tu marca en PetitPrime" />
            </Helmet>

            <div className="container mx-auto px-4 py-8">
                <NotificationConfig />
            </div>
        </>
    );
};

export default NotificationSettings; 